import { render } from "./VisitPredictionDashboard.vue?vue&type=template&id=482be1d1&scoped=true"
import script from "./VisitPredictionDashboard.js?vue&type=script&lang=js"
export * from "./VisitPredictionDashboard.js?vue&type=script&lang=js"

import "./VisitPredictionDashboard.vue?vue&type=style&index=0&id=482be1d1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482be1d1"]])

export default __exports__